import React from 'react';
import { Button, Row, Col, Divider } from 'antd';

const DrawerFooter = ({ onSaveClick, onCancel }) => {
  return (
    <div style={{ width: '100%', marginBottom: '8px', marginTop: '8px' }}>
      <Row gutter={16}>
        <Col span={12}>
          <Button
            block
            onClick={onCancel}
            style={{ backgroundColor: '#F4F5F7', border: 'none', height: '36px' }}>
            Huỷ
          </Button>
        </Col>
        <Col span={12}>
          <Button
            block
            type="primary"
            onClick={onSaveClick}
            style={{ backgroundColor: '#0051A9', color: '#FFFFFF', height: '36px' }}>
            Tìm kiếm
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default DrawerFooter;
